import React from "react";
import SVG from "react-inlinesvg";

import Modal from "@app/components/ui/modals/Modal";
import cupIcon from '@src/images/landing/cup';
import medalIcon from '@icons/reward/medal'
import certificateIcon from '@icons/reward/certificate'

const ResultLearnModal = ({ student, modal, onClose }) => {
  const { participation: { olympiad } } = student
  const achievementThreshold = olympiad.diploma_score
  const meritThreshold = olympiad.charter_score

  return (
    <Modal ref={modal} className="about-certificates-modal" closeButton={false}>
      <div className="about-certificates-modal__inner">
        <h2 className="about-certificates-modal__header">Certificates for Students</h2>
        <p className="about-certificates-modal__description">
          Certificates are given based on&nbsp;the points you score during the Olympiad.
          If&nbsp;you solve at&nbsp;least 1 task, you will get a&nbsp;reward.
        </p>
        <p className="about-certificates-modal__note">
          Your certificate will be&nbsp;ready after the Olympiad ends and all the results are counted.
        </p>
        <h2 className="about-certificates-modal__header">Certificates for Students</h2>
        <div className="about-certificates-modal__list">
          <div className="about-certificates-modal__item">
            <SVG src={cupIcon} />
            <span className="about-certificates-modal__label">
              <strong>Achievement:</strong> {achievementThreshold}+ points
            </span>
          </div>
          <div className="about-certificates-modal__item">
            <SVG src={medalIcon} />
            <span className="about-certificates-modal__label">
              <strong>Merit:</strong> {meritThreshold}–{achievementThreshold-1} points
            </span>
          </div>
          <div className="about-certificates-modal__item">
            <SVG src={certificateIcon} />
            <span className="about-certificates-modal__label">
              <strong>Participation:</strong> {meritThreshold-1} or fewer
            </span>
          </div>
        </div>
        <div className="modal-content__buttons w-flex-layout w-flex-layout--columns mb-0">
          <button className="btn btn--blue btn--md mb-0" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ResultLearnModal;
